// extracted by mini-css-extract-plugin
module.exports = {"recent":"MyLookpinRecents_recent__1cFEN","sub-title":"MyLookpinRecents_sub-title__3JyV7","images":"MyLookpinRecents_images__108mF","sold-out":"MyLookpinRecents_sold-out__rd28p"};